import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { TimeSpan } from "../helpers/time-span";

export function StopTimeValidator(startFieldName: string, stopFieldName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const sourceCtrl = control.get(startFieldName);
    const targetCtrl = control.get(stopFieldName);

    var startIsLargerThanStop = false;

    if(sourceCtrl.value && targetCtrl.value){
      const startTimeSpan = TimeSpan.parse(sourceCtrl.value);
      const stopTimeSpan = TimeSpan.parse(targetCtrl.value);

      if(startTimeSpan.getTotalSeconds() >= stopTimeSpan.getTotalSeconds()){
        startIsLargerThanStop = true;
      }
    }


      return startIsLargerThanStop
      ? { startIsLargerThanStop: true }
      : null;
  };
  }